<form class="change-password-form" [formGroup]="changePasswordFormGrp">
  <!-- <div class="warning-container">
  <p>
    {{ "auth.pwd_requirements" | translate }}
  </p>
  <ol>
    <li>{{ "auth.pwd_requirements_msg1" | translate }}</li>
    <li>{{ "auth.pwd_requirements_msg2" | translate }}</li>
    <li>{{ "auth.pwd_requirements_msg3" | translate }}</li>
    <li>{{ "auth.pwd_requirements_msg4" | translate }}</li>
    <li>{{ "auth.pwd_requirements_msg5" | translate }}</li>
  </ol>
</div> -->

<!--Current Password-->
  <div class="password-container" [ngStyle]="{
    'margin-bottom': changePasswordFormGrp.get('currentPassword')?.touched && changePasswordFormGrp.get('currentPassword')?.errors ? '0px' : '0px'
  }">
  <uw-password label="{{'auth.current_password' | translate}}" formControlName="currentPassword"
    [passwordStrengthEnabled]="false">
  </uw-password>

  @if (changePasswordFormGrp.get('currentPassword')?.touched && changePasswordFormGrp.get('currentPassword')?.hasError(
    'required'
    )) {
    <mat-error class="error-message">
      {{ "messages.field_is_required" | translate }}
    </mat-error>
  }
</div>

<uw-password-registration passwordLabel="{{ 'auth.new_password' | translate }}" formControlName="passwordRegistration"></uw-password-registration>

  <div class="flex-column-center" [ngStyle]="{
    'margin-top': changePasswordFormGrp.get('passwordRegistration')?.errors ? '20px' : '0px'
  }">
  <uw-button [loading]="buttonLoading" [isMediumSize]="true" (click)="onChangePassword()"
  btnLabel="{{ actionButtonLabel | translate }}"></uw-button>
</div>
</form>
